export default {
    desktop: "1400px",
    mobile: "769px",
}